<ng-container *ngIf="nextDialTarget$ | async; let targetInfo">
   <div class="next-dial-target" *ngIf="targetInfo.number !== ''">
      <div fxFlex="1 1 20" style="position: relative">
         <samweb-avatar
            [dn]="targetInfo.number"
            [showPresenceStatus]="false"
            fxFlex="0 0 100"
            class="next-dial-target-avatar"
         >
         </samweb-avatar>
         <div class="content" fxFlex="1 1 auto" (click)="callTarget()" fxLayoutAlign="center center">
            <div samwebAutoFitFontSize class="fa-layers">
               <fa-icon [icon]="dialArrowIcon" transform="shrink-8 right-4 up-6"></fa-icon>
               <fa-icon [icon]="phoneAnswerIcon"></fa-icon>
            </div>
         </div>
      </div>
      <div fxFlex="1 1 70" class="target-info">
         <div fxLayout="column">
            <div *ngIf="targetInfo.name !== ''" fxFlex="1 1 auto" style="font-size: 1.17em; font-style: italic">
               {{ targetInfo.name }}
            </div>
            <div fxFlex="1 1 auto" class="callable" (click)="callTarget()">
               <div class="sam-ellipsis-on-overflow">
                  {{ targetInfo.number }}
               </div>
            </div>
         </div>
      </div>
      <div fxFlex="1 1 10" style="position: absolute; right: 0">
         <fa-icon [icon]="bullsEyeIcon"></fa-icon>
      </div>
   </div>
</ng-container>
